import React from 'react';
import _ from 'lodash';
import verticalProduct from '../../assets/pictures/verticalProduct.png';
import horizontalProduct from '../../assets/pictures/horizontalProduct.png';

export const initStates = async (design, setStateObj) => {
  setStateObj({
    isLoading: false,
    selectedProduct: design === 2 ? 1 : 0
  });
};

export const changeSwitchValue = (newValue, imageCoverOrderUrl, setStateObj) => {
  setStateObj({
    picture: imageCoverOrderUrl,
    selected: newValue
  });
};
export const changeSwitchValueMode = async (newValue, setStateObj) => {
  await setStateObj({
    selectedProduct: newValue
  });
};
export const handleClick = (event, index, setStateObj, title) => {
  setStateObj({ config: title, title });
};

export const getCommonBottomNavigationData = classes => {
  const data = ['Vertical', 'Horizontal'];
  const newData = [];
  _.map(data, e => {
    newData.push({
      label: e,
      icon:
        e === data[0] ? (
          <img src={verticalProduct} alt='' className={classes.verticalProductIcon} />
        ) : (
          <img src={horizontalProduct} alt='' className={classes.horizontalProductIcon} />
        )
    });
  });
  return newData;
};
